import React from "react";
import { CalendarDayEventBlockParams } from "../CalendarDayEventBlock/CalendarDayEventBlockParams.csharp";
import { CalendarDayEventBlock } from "./CalendarDayEventBlock";

interface CalendarDayEventBlockListParams {
  items: CalendarDayEventBlockParams[];
  itemsWhiteBg?: boolean;
}

export const CalendarDayEventBlockList: React.FC<
  CalendarDayEventBlockListParams
> = ({ items, itemsWhiteBg }) => {
  return (
    <ul className="calendar-day-event-block-list">
      {items.map((item, index) => (
        <CalendarDayEventBlock key={index} {...item} whiteBg={itemsWhiteBg} />
      ))}
    </ul>
  );
};
